import $ from 'jquery';
import avalon from 'avalon';
import slider from '../../modules/slider/0.0.0/slider';
import tool from '../../modules/tool/0.0.0/tool';
import ajax from '../../modules/ajax/0.0.0/ajax';
import pagination from '../../modules/pagination/0.0.0/pagination';

var hiddenValues = null,
    localHiddensGlobal,
    pages,
    urlParam,
    vmodel = avalon.define({
        $id: 'indexController',
        list: [],
        isAjaxGetData: false,
        consultPagination: pagination.init(0, 0, 0),
        index_title: '进行中',
        consultGoPage: function (page) {
            if (page.disable) {
                return;
            }
            // console.log(page)
            ajax.pjax('?page=' + page.target + '&' + urlParam);
        },

        sendEventTracking: function (n) {
            tool.sendEventTracking('pc', n);
        },

        toTopVisible: true,
        toTopPositionBottom: 335,
        toTop: function () {
            tool.scrollTo($('#header'));
        },
        rendered: function () {
            $('img[data-original]').lazyload({
                effect: 'fadeIn',
                placeholder:
                    localHiddensGlobal.frontUrl +
                    'dest/shangou/images/placeholder.jpg',
                threshold: 300
            });
        },
        getPanicPrice: function (el) {
            var price =
                tool.toNumber(el.min_price) - tool.toNumber(el.panic_discount);
            price = price <= 0 ? 0 : price;
            price = tool.toMoney(price);
            return Number(price);
        }
    });

export default {
    init: function () {
        hiddenValues = tool.getHiddenValues('#js-local-hiddens');
        localHiddensGlobal = tool.getHiddenValues('#js-hiddens');

        console.log(localHiddensGlobal);

        if (localHiddensGlobal.skin_on_off === '1') {
            let index_title = localHiddensGlobal.skin_config.index_title;
            if (index_title.indexOf('http://') === -1) {
                vmodel['index_title'] = index_title;
            }
        }

        var imgs = [];
        $.each(hiddenValues.ad_list, function (i, img) {
            imgs.push(img.img);
        });

        slider.init({
            selector: '#js-slider',
            height: 480,
            width: '100%',
            auto: true,
            forBg: true,
            imgs: imgs,
            onClick: function (index) {
                index = tool.toNumber(index);
                ajax.pjax(hiddenValues.ad_list[index - 1].url);
            },
            pagination: {
                selector: '#js-slider-pagination',
                width: '100%',
                height: 10,
                itemWidth: 10,
                maxItemLength: 100,
                render: function (item) {
                    return item.html();
                }
            }
        });

        var goodsList = hiddenValues.goods_list.data;
        for (var i = 0; i < goodsList.length; i++) {
            goodsList[i].sell_total = null;
            goodsList[i].sku_total = null;
        }
        vmodel.list = goodsList;
        // console.log(vmodel.list.$model)

        pages = hiddenValues.goods_list.pages;
        urlParam = hiddenValues.url_param;

        vmodel.consultPagination = pagination.init(
            pages.total,
            pages.curpage,
            pages.pageSize
        );

        tool.onWindowScroll.on(function (e, top) {
            if (top === 0) {
                vmodel.toTopVisible = false;
            } else {
                vmodel.toTopVisible = true;
            }

            var clientHeight = tool.getClientHeight(),
                scrollHeight = tool.getScrollHeight();

            if (scrollHeight - clientHeight - top < 335) {
                vmodel.toTopPositionBottom =
                    335 - (scrollHeight - clientHeight - top);
            } else {
                vmodel.toTopPositionBottom = 20;
            }
        });

        // 动态获取销量数据
        var multiId = [];
        for (var i = 0; i < goodsList.length; i++) {
            multiId.push(goodsList[i].id);
        }
        ajax.postWithFail('/goods/default/goods-sale.html', {
            multi_id: multiId.join(',')
        }).done(function (response) {
            for (var i = 0; i < goodsList.length; i++) {
                vmodel.list[i].sell_total =
                    response.msg[goodsList[i].id].sell_total;
                vmodel.list[i].sku_total =
                    response.msg[goodsList[i].id].sku_total;
            }
            vmodel.isAjaxGetData = true;
        });

        vmodel.sendEventTracking(10100);
    },
    clear: function () {}
};



// WEBPACK FOOTER //
// ./src/js_modules/indexController.js